// requires lodash! keep in mind when moving sharing into twig
import debounce from 'lodash/debounce';
import once from 'lodash/once';
import {scrollDepthEvent} from './ctas';
import {fireGtagEvent} from './helpers/gtag-helpers';

const allPercentsAreValid = percents => {
  const LOWER_BOUND = 0;
  const UPPER_BOUND = 100;
  const isInRange = percent => (percent >= LOWER_BOUND && percent <= UPPER_BOUND);

  return percents.reduce((isValid, p) => isValid === false ? isValid : isInRange(p), null);
}

// TODO good candidate for test
const getDepths = ({window, element, percents, triggers}) => {
  const elementHeight = element.getBoundingClientRect().height;
  const elementToTopGap = element.getBoundingClientRect().top + window.scrollY;

  return percents.map(p => ({
    pixels: elementHeight * (p / 100) + elementToTopGap,
    callback: triggers[p],
    percent: p,
  }))
}

const getTriggers = (percentsAtWhichToFire) => {
  return percentsAtWhichToFire.reduce((acc, int) => {
    return {
      ...acc,
      [int]: once((label) => {
        const {name, category, nonInteraction} = scrollDepthEvent;

        fireGtagEvent(name, `${label}%`, category, nonInteraction);
      }),
    }
  }, {});
}


const getController = (triggers, element, percents, window) => {
  const DEBOUNCE_TIME = 200;

  const onViewport = debounce(() => {
    const windowY = window.pageYOffset + window.innerHeight;
    const depths = getDepths({element, percents, window, triggers})

    for (let i = 0; i < depths.length; i++) {
      const currentDepth = depths[i];
      const {pixels, callback, percent} = currentDepth;

      if (pixels > windowY) break;

      callback(percent)

      if (i === depths.length - 1) {
        unbindListeners();
      }
    }
  }, DEBOUNCE_TIME);

  const bindListeners = () => {
    window.addEventListener('scroll', onViewport);
    window.addEventListener('resize', onViewport);
  }

  const unbindListeners = () => {
    window.removeEventListener('scroll', onViewport, false);
    window.removeEventListener('resize', onViewport, false);
  }

  return {
    onViewport,
    bindListeners
  }
}

export default (trackedElemClass, percentsAtWhichToFire) => {
  const contentEl = document.querySelector(trackedElemClass);

  if (!contentEl) {
    return;
  }

  if (!allPercentsAreValid(percentsAtWhichToFire)) {
    return;
  }

  const triggers = getTriggers(percentsAtWhichToFire);
  const controller = getController(triggers, contentEl, percentsAtWhichToFire, window);
  controller.bindListeners()
};
